module.exports = __webpack_public_path__ + "static/media/03-weekend-default.32f677b5.png";